// Full-screen fan control route — wraps the shared FanDial in device chrome.
// (In the desktop shell fans render inline on their room card via FanDial, so
// this is the standalone /device route / small-screen fallback.)

import React from 'react';
import { Box } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import FanDial from '../../components/FanDial';

export default function FanScreen({ device, initialStatus = '' }) {
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <Box sx={{ mt: 2 }}>
        <FanDial device={device} size={264} initialStatus={initialStatus} />
      </Box>
    </DeviceShell>
  );
}
